// extracted by mini-css-extract-plugin
export default {"page":"gO","top_block":"hO","heading":"iO","inner_text":"jO","starter_text":"kO","starter_cta":"lO","summary_block":"mO","cartsummary_wrap":"nO","price":"oO","pricing_wrap":"pO","summary_block_mob":"qO","summary":"rO","pricing_heading":"sO","products_summary":"tO","summary_line":"uO","summary_price":"vO","summary_title":"wO"};
    if(module.hot) {
      // 1715276859116
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  